import indicatorRegistry from "../Registry/Indicators/IndicatorRegistry";
import { updateIndicatorDisplayName } from "./indicatorDisplayName.js";
import { setIndicatorRenderKey } from "../store/chart/chartState.js";

// Single source for building a new indicator instance from a registry entry.
// Extracted verbatim from RegistryIndicatorsDropdown.createIndicator so the
// chart context menu ("Estudos" section) adds indicators through the exact
// same flow as the navbar picker.
export const createIndicatorInstance = (
  categoryKey,
  indicatorKey,
  options,
  appearanceOptions,
  chartIndicators = [],
) => {
  const category = indicatorRegistry[categoryKey];
  const indicator = category?.indicators?.[indicatorKey];
  if (!indicator) return null;
  const id = `${indicatorKey}_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
  const newIndicator = {
    ...indicator,
    id,
    config: options,
    appearanceConfig: appearanceOptions,
    categoryKey,
    categoryDisplayName: category.displayName,
  };

  // IMPORTANT: Set renderKey FIRST before updating display name
  setIndicatorRenderKey(newIndicator);

  // Update displayName to include series source if applicable
  updateIndicatorDisplayName(newIndicator, chartIndicators);

  return newIndicator;
};
